import { useVideoPlayback } from "@/contexts/playback-context";
import { batch } from "@legendapp/state";
import {
  MediaPlayerClass,
  PlaybackErrorEvent,
  ErrorEvent,
  MediaPlayer,
  ManifestLoadedEvent,
} from "dashjs";
import toast from "react-hot-toast";
import { ManifestLoadedData } from "../types";

export const useHandleDashErrors = (dashPlayer: MediaPlayerClass) => {
  const videoPlayback = useVideoPlayback();

  const onPlaybackEnded = () => {
    console.log("end");
  };

  const onPlaybackError = (event: PlaybackErrorEvent) => {
    videoPlayback.videoContext.error.set(event);
    toast.error(
      (event.error as any)?.message ||
        "Unexpected error occurred. Cannot play a video."
    );
  };

  const onError = (event: ErrorEvent) => {
    videoPlayback.videoContext.error.set(event);
    toast.error(
      (event.error as any)?.message ||
        "Unexpected error occurred. Cannot play a video."
    );
  };

  const onPlaybackMetadataLoaded = () => {
    const duration = dashPlayer.duration(); // in seconds
    batch(() => {
      videoPlayback.videoContext.duration.set(duration);
      videoPlayback.videoContext.endTime.set(
        new Date(
          videoPlayback.videoContext.startTime.peek().getTime() +
            duration * 1000
        )
      );
    });
  };

  const onManifestLoaded = (e: ManifestLoadedEvent) => {
    const { availabilityStartTime } = e.data as ManifestLoadedData;
    videoPlayback.videoContext.availabilityStartTime.set(availabilityStartTime);
  };

  const attachEventListeners = () => {
    dashPlayer.on("playbackEnded", onPlaybackEnded);
    dashPlayer.on("playbackError", onPlaybackError);
    dashPlayer.on("playbackMetaDataLoaded", onPlaybackMetadataLoaded);
    dashPlayer.on("error", onError);
    dashPlayer.on(MediaPlayer.events.MANIFEST_LOADED, onManifestLoaded);
  };

  const detachEventListeners = () => {
    dashPlayer.off("playbackEnded", onPlaybackEnded);
    dashPlayer.off("playbackError", onPlaybackError);
    dashPlayer.off("playbackMetaDataLoaded", onPlaybackMetadataLoaded);
    dashPlayer.off("error", onError);
    dashPlayer.off(MediaPlayer.events.MANIFEST_LOADED, onManifestLoaded);
  };

  return { attachEventListeners, detachEventListeners };
};
